/**
 * Definition of all routes of the application.
 */
export const routes = {
  overview: {
    url: 'overview',
    absoluteUrl: '/overview',
  },
  machineTasks: {
    url: 'machine-tasks',
    absoluteUrl: '/machine-tasks',
    params: {
      serial: 'serial',
    },
  },
  machineHistory: {
    url: 'machine-history',
    absoluteUrl: '/machine-history',
  },
  toolingTasks: {
    url: 'tooling-tasks',
    absoluteUrl: '/tooling-tasks',
    params: {
      tooling: 'tooling',
    },
  },
  toolingHistory: {
    url: 'tooling-history',
    absoluteUrl: '/tooling-history',
  },
  unhandledError: {
    url: 'serverunhandlederror',
    absoluteUrl: '/serverunhandlederror',
  },
};
